import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", function () {
  casesSlider();
});

// Cases Slider
function casesSlider() {
  let sliders = document.querySelectorAll(".cases-slider__wrapper");  
  let slider_with_image = document.getElementsByClassName('slider_with_image');
  let perView = ( slider_with_image.length > 0) ? 1 : 2.4;
  sliders.forEach((sliderElement) => {
    let slider = new Glide(sliderElement, {
      type: "slider",
      startAt: 0,
      perView: perView,
      gap: 24,
      focusAt: 0,
      rewind: false,
      breakpoints: {
        767: {
          perView: 1,
        },
      },
    });

    slider.mount();
  });
}